import React from "react";
import styled from "styled-components";

const handleColorType = (module, theme) => {
  switch (module) {
    case "storage":
      return theme.storage;
    case "account":
      return theme.account;
    case "billing":
      return theme.billing;
    case "support":
      return theme.support;
    case "colocation":
      return theme.colocation;
    default:
      return theme.main;
  }
};

const DailySVG = styled.svg`
  width: 15px !important;
  height: 20px !important;

  .hourly,
  .hourly-1,
  .hourly-2,
  .hourly-3 {
    fill: #a2a9ad;
  }
`;

export const DocSelector = (props) => {
  const { id, theme, module, position, className } = props;
  const rotate = position === "left" ? "rotate(90)" : "rotate(270)";
  return (
    <DailySVG
      id={id}
      module={module}
      width="8.582"
      height="8.582"
      viewBox="0 0 1000 1000"
      enableBackground="new 0 0 1000 1000"
      xmlSpace="preserve"
    >
      <defs>
        <linearGradient
          id={`${id}-swipe-gradient`}
          x1="0.5"
          y1="1"
          x2="0.5"
          y2="-2"
          gradientTransform={rotate}
        >
          <stop offset="0" stop-color="white">
            <animate
              id={`${id}trans1`}
              dur="0.7s"
              attributeName="offset"
              fill="freeze"
              from="0"
              to="1"
              restart="always"
              begin="indefinite"
            />
          </stop>
          <stop offset="0" stop-color={handleColorType(module, theme)}>
            <animate
              id={`${id}trans1`}
              dur="0.7s"
              attributeName="offset"
              fill="freeze"
              from="0"
              to="1"
              restart="always"
              begin="indefinite"
            />
          </stop>
        </linearGradient>
      </defs>
      <g>
        {/* <path
				id='Doc'
				d='M51.33,55.35A4.37,4.37,0,0,1,47,51V41.37a2.61,2.61,0,0,1,.77-1.85,2.68,2.68,0,0,1,3.71,0,2.61,2.61,0,0,1,.77,1.86v8.74H50.46V41.37a.87.87,0,0,0-.26-.62.89.89,0,0,0-1.23,0,.87.87,0,0,0-.26.62V51a2.65,2.65,0,0,0,.77,1.86,2.69,2.69,0,0,0,3.71,0A2.65,2.65,0,0,0,54,51V41.37a4.37,4.37,0,0,0-8.74,0v6.21H43.47V41.37a6.12,6.12,0,1,1,12.23,0V51a4.37,4.37,0,0,1-4.37,4.37Z'
				class={className}
				transform='translate(-43.47 -35.25)'
                /> */}
        <path
          class={className}
          d="M241.7,520.5h422.6c11.3,0,20.5-9.2,20.5-20.5s-9.1-20.4-20.5-20.4H241.7c-11.3,0-20.4,9.1-20.4,20.4S230.5,520.5,241.7,520.5z"
        />
        <path
          class={className}
          d="M758.3,620.4H241.7c-11.3,0-20.4,9.1-20.4,20.5c0,11.3,9.1,20.5,20.4,20.5h516.5c11.3,0,20.5-9.1,20.5-20.5C778.7,629.5,769.6,620.4,758.3,620.4z"
        />
        <path
          class={className}
          d="M758.3,761.3H241.7c-11.3,0-20.4,9.1-20.4,20.5c0,11.3,9.1,20.4,20.4,20.4h516.5c11.3,0,20.5-9.1,20.5-20.4C778.7,770.4,769.6,761.3,758.3,761.3z"
        />
        <path
          class={className}
          d="M919.3,311c-0.1-1.9-0.5-3.8-1.1-5.6c-0.2-0.6-0.4-1.2-0.6-1.8c-1-2.1-2.2-4.2-4-6L631.9,16c-1.8-1.8-3.8-3-6-4c-0.6-0.2-1.1-0.4-1.7-0.6c-1.9-0.7-3.7-1-5.7-1.1c-0.4,0-0.8-0.2-1.2-0.2H241.7c-89,0-161.3,72.4-161.3,161.3v657.4c0,88.9,72.4,161.3,161.3,161.3h516.5c88.9,0,161.3-72.4,161.3-161.3V312.2C919.6,311.7,919.4,311.4,919.3,311z M637.8,79.8l211.9,211.9H687.8c-27.6,0-50-22.4-50-50V79.8z M758.3,949.1H241.7c-66.4,0-120.4-54-120.4-120.4V171.3c0-66.4,54-120.4,120.4-120.4H597v190.9c0,50.1,40.8,90.9,90.8,90.9h190.8v496.1C878.7,895.1,824.6,949.1,758.3,949.1z"
        />
      </g>
    </DailySVG>
  );
};
